export type MarketingConsent = "granted" | "denied" | "unknown";

export function getMarketingConsent(): MarketingConsent {
  try {
    const value = JSON.parse(localStorage.getItem("pp_marketing_analytics_consent_v1") ?? "null") as { state?: unknown } | null;
    return value?.state === "granted" || value?.state === "denied" ? value.state : "unknown";
  } catch {
    return "unknown";
  }
}

export function setMarketingConsent(state: Exclude<MarketingConsent, "unknown">) {
  localStorage.setItem("pp_marketing_analytics_consent_v1", JSON.stringify({ state, updatedAt: new Date().toISOString() }));
}

export function withdrawMarketingConsent() {
  setMarketingConsent("denied");
}
